import SdkDisclosureTable from './SdkDisclosureTable'

export default SdkDisclosureTable
